"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = void 0;
exports.Routes = {
    CREATE_TICKET: '/ticket'
};
//# sourceMappingURL=SupportTicket.consts.js.map